<!--
 * @Author: yihao yihao@meiomedical.com
 * @Date: 2025-08-16 23:25:17
 * @LastEditors: yihao yihao@meiomedical.com
 * @LastEditTime: 2025-10-14 09:51:45
 * @FilePath: \website_vue1\src\views\About_IPDetail_Item.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div ref="itemWrapper">
    <h1 class="ipdetailitemvalue">{{ displayValue }}+</h1>
    <p class="ipdetailitemname">{{ item_name }}</p>
  </div>
</template>

<script>
export default {
  name: "AboutIPDetailItem",
  props: {
    item_name: String,
    item_value: String
  },
  data() {
    return {
      displayValue: 0,
      hasAnimated: false
    };
  },
  mounted() {
    // 使用 IntersectionObserver 监听滚动到可视区域
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.hasAnimated = true;
            const numericVal = Number(this.item_value);
            if (!isNaN(numericVal)) {
              this.animateNumber(numericVal);
            }
          }
        });
      },
      {
        threshold: 0.5 // 当元素 50% 出现在可视区域时触发
      }
    );

    observer.observe(this.$refs.itemWrapper);
  },
  methods: {
    animateNumber(target) {
      const start = 0;
      const end = Number(target);
      const duration = 1500; // 动画持续时间 ms
      const startTime = performance.now();

      const update = (now) => {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        this.displayValue = Math.floor(progress * (end - start) + start);
        if (progress < 1) {
          requestAnimationFrame(update);
        }
      };

      requestAnimationFrame(update);
    }
  }
};
</script>

<style scoped>
.ipdetailitemvalue {
  color: white;
  font-size: var(--title-big-font-size);
  text-align: center;
  margin-bottom: 1.9rem;
}

.ipdetailitemname {
  color: white;
  font-size: 1.2rem;
  text-align: center;
}

@media (max-width: 768px) {

  .ipdetailitemvalue{
    font-size: 3rem;
        margin: 3rem 0px;
  }

}

</style>
